import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FooterStyle } from '../../../styles/FooterStyle';
import { List } from '@material-ui/core';

const footerStyle = FooterStyle;

function Footer(props) {
    const footerClasses = footerStyle();
    const [footer, setFooter] = useState([]);

    useEffect(() => {
        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/footer`)
            .then((response) => {
                setFooter(response.data);
            })
            .catch((error) => {
            });
    }, []);

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>

            <footer className={footerClasses.footer}>
                <div className={footerClasses.footerBackground}></div>
                <div className={footerClasses.containerFooter}>
                    <div className={footerClasses.footerContent}>
                        <div className={footerClasses.footerBox}>
                            <div className={footerClasses.footerlinks}>
                                <Link className={footerClasses.link} to="/aboutUs" >
                                    {'About us'}
                                </Link>

                                <Link className={footerClasses.link} to="/ourWork" >
                                    {'Our Work'}
                                </Link>
                                <Link className={footerClasses.link} to="/news" >
                                    {'News'}
                                </Link>
                                <Link className={footerClasses.link} to="/careers" >
                                    {'Careers'}
                                </Link>

                                <Link className={footerClasses.link} to="/contact">
                                    {'Contact'}
                                </Link>
                                <Link className={footerClasses.link} to="/terms&Conditions">
                                    {'Terms & Conditions'}
                                </Link>
                                <a className={footerClasses.link} target="_blank" rel="noopener noreferrer" href="https://sites.google.com/footballco.com/media-kit/home">
                                    {'Media Kit'}
                                </a>
                            </div>
                            <div className={footerClasses.boxSocialMedia}>
                                {footer.length === 0 || footer.Social_media.length === 0 || footer.Social_media.length === '' ? '' :
                                    footer.Social_media.map((items, i) => (

                                        <a className={footerClasses.link} href={items.Url} key={i} target='_blank' rel="noreferrer">
                                            <img
                                                src={replace(items.Image.url)}
                                                alt={items.Name}
                                                classes={{ root: footerClasses.socialMedia }}
                                            />
                                        </a>
                                    ))
                                }
                            </div>
                        </div>
                        <div className={footerClasses.footerContentP}>
                            <Link className={footerClasses.link} to="/home">
                                <span>
                                    {footer.length === 0 || footer.Social_media.length === 0 || footer.Social_media.length === '' ? '' :
                                        <img
                                            src={replace(footer.Logo.url)}
                                            alt={footer.Logo.name}
                                        />
                                    }
                                </span>
                            </Link>
                        </div>
                        <div className={footerClasses.footerInformation}>
                            <ul>
                                <li><span>Registered office</span></li>
                                <li>FootballCo Media Limited</li>
                                <li>72 Dean Street</li>
                                <li>London</li>
                                <li>W1D 3SG</li>
                            </ul>
                            <p>
                                FootballCo Media Limited ("we", "us" or "FootballCo") is a business division of the FootballCo Group, headquartered in the UK. <br />  
                                The FootballCo Group is a group of companies which own, operate (either for ourselves or on behalf of third-parties) or represent 
                                a number of free-to-use digital sports media properties (as seen on our "About Us" page), which are either websites or mobile applications
                            </p>

                        </div>
                    </div>
                </div>
            </footer>
        </React.Fragment>
    );
}

export default withRouter(Footer);
